// extracted by mini-css-extract-plugin
export default {"container":"DBHK","addCompany":"QX1q","btn":"RsLR","headerLineWrapper":"_5H0I","headerLine":"KS_J","headerCell":"Oyx0","loader":"lBl4"};